import { isBooksProduct } from "src/api/booksProducts";
export default function getPreviewImage(product) {
    const isBooks = isBooksProduct(product);
    if (isBooks) {
        return null;
    } else if (typeof product.source.images === "object" && "previews" in product.source.images) {
        return product.source.images.previews;
    } else {
        return [];
    }
}
